const config = {
  BASE_URL:
    window.location.hostname.includes("test.sharik.app") ||
    window.location.hostname.includes("localhost")
      ? "https://api.test.sharik.app/v1/"
      : "https://api.sharik.app/v1/",
};

export default config;
